import React, { useState, useEffect } from "react";
import { useAuthProvider } from "pages/Auth/hooks/useAuthProvider";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { portalActions } from "../../../store/portal-slice";
import { persistor } from "store/index";
import { clearLocalStore } from "helpers/localStoreSrv";
import { Result } from "antd";

const LandingMicrosite: React.FC<{
  target: string;
  auth?: string;
  urlRef?: string;
}> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { initAuth, isSessionAuthenticated } = useAuthProvider();

  useEffect(() => {
    const prepareSessionData = async () => {
      await persistor.purge();
      await persistor.flush();
      clearLocalStore();
      console.log("props...........",props)
      const sessionPayload = {
        isAgreed: false,
        urlRef: props.urlRef,
        targetComponent: props.target,
        landingUrlSnapshot: location.pathname,
      };
      dispatch(portalActions.setMicrositeSession(sessionPayload));
    };

    prepareSessionData();
  }, [props.urlRef, props.target, location.pathname, dispatch]);

  useEffect(() => {
    clearLocalStore();
    const navToTarget = () => {
      if (isSessionAuthenticated()) {
        navigate(props.target);
      } else {
        initAuth(props.auth);
      }
    };
    navToTarget();
  }, [props.target, props.auth, isSessionAuthenticated, navigate, initAuth]);

  return (
    <Result
      data-testid="landing-microsite-container"
      status="success"
      title="Welcome to HealConnect Member Portal"
      subTitle="This is your Microsite landing."
    />
  );
};
export default LandingMicrosite;
